import moment from 'moment'

import {
  DEADLINE_FIELD,
  KIND_FIELD,
  MESSAGE_FIELD,
  MESSAGES_FIELD,
  RECEIVER_FIELD,
  SENDER_FIELD,
  SUBJECT_FIELD,
  TEMPLATE_ID_FIELD,
  getTemplate,
  JOB_STATUSES,
  WORKSPACE_STATUSES,
  JOB_TEMPLATE_MODE,
} from './model'

export const mapPropsToInternalState = state => {
  const {
    candidates = [],
    company,
    deadline,
    name: projectName,
    templates = [],
    mode = JOB_TEMPLATE_MODE,
  } = state ?? {}

  return {
    [MESSAGES_FIELD]: candidates.map(candidate => {
      const { deadline_date, email, id, language, name, quiz_url, status } =
        candidate

      const template = getTemplate({ language, status, templates, mode })

      const term =
        deadline_date ||
        deadline ||
        moment().add(7, 'days').format('YYYY-MM-DD')

      const interpolate = text =>
        (text || '')
          .replace(/\{{2}\s*\w+\s*\}{2}/g, match => {
            if (match.includes('name')) return name
            if (match.includes('deadline'))
              return moment(term).locale(language).format('LL')
            if (match.includes('url')) return quiz_url
            if (match.includes('contact_email')) return 'ebber@ebber.com'

            if (mode === JOB_TEMPLATE_MODE) {
              if (match.includes('company')) return company
              if (match.includes('project')) return projectName
              if (match.includes('url')) return quiz_url
            }

            return ''
          })
          .trim()

      return {
        key: id,
        [DEADLINE_FIELD]: term,
        [KIND_FIELD]:
          mode === JOB_TEMPLATE_MODE
            ? JOB_STATUSES[status]
            : WORKSPACE_STATUSES[status],
        [RECEIVER_FIELD]: email,

        [SENDER_FIELD]: template?.sender_name ?? '',

        [SUBJECT_FIELD]: interpolate(template?.subject),

        [MESSAGE_FIELD]: interpolate(template?.body),

        [TEMPLATE_ID_FIELD]: template?.id ?? null,
      }
    }, candidates),
  }
}
